import { Component, Input, OnInit } from '@angular/core';
import {LanguagePipe} from "../../../pipe/language.pipe";


@Component({
  selector: 'app-ecommerce-order-status-indicators',
  templateUrl: './ecommerce-order-status-indicators.component.html',
  styleUrls: ['./ecommerce-order-status-indicators.component.css']
})
export class EcommerceOrderStatusIndicatorsComponent implements OnInit {
  @Input() remoteOrderStateStatus: string;
  @Input() uniqueRemoteOrderIdStatus: string;
  @Input() userHoldStatus: string;
  @Input() costVsRevenueStatus: string = 'INITIAL';
  @Input() revenueStatus: string = 'INITIAL';
  @Input() releaseStatus: string;
  @Input() ecommerceOrderStatus: string;
  @Input() addressStatus: string = 'INITIAL';
  @Input() productStatus: string = 'INITIAL';
  @Input() carrierServiceLevelStatus: string = 'INITIAL';
  @Input() functionalStatus: string = 'INITIAL';
  @Input() showSymbolMeanings: boolean = true;
  @Input() checkCostVsRevenue: boolean = true;
  @Input() ignoreStatus: string = 'NOT_IGNORE';

  languageString: LanguagePipe = new LanguagePipe();

  constructor() { }

  ngOnInit(): void {
    // Lifecycle hook for initialization logic if needed
  }

  show(fieldName): boolean {
    switch (fieldName) {
      case 'remoteOrderStateStatus': {
        return this.remoteOrderStateStatus === 'REVIEW' || this.remoteOrderStateStatus === 'USER_OVERRIDE' ? true : false;
      }
      case 'uniqueRemoteOrderIdStatus': {
        return this.uniqueRemoteOrderIdStatus === 'ERROR' ? true : false;
      }
      case 'ignoreStatus': {
        return this.ignoreStatus === 'IGNORE' ? true : false;
      }
      case 'userHoldStatus': {
        return this.userHoldStatus === 'HOLD' ? true : false;
      }
      case 'releaseStatus': {
        return this.releaseStatus !== 'INITIAL' ? true : false;
      }
      case 'functionalStatus': {
        return this.functionalStatus !== 'INITIAL' ? false : false;
      }
      case 'ecommerceOrderStatus': {
        return this.ecommerceOrderStatus !== 'INITIAL' && this.ecommerceOrderStatus !== 'VALID_COMPUTE_TAX' ? true : false;
      }
      case 'addressStatus': {
        return this.addressStatus !== 'SUCCESS' && this.addressStatus !== 'INITIAL' ? true : false;
      }
      case 'productStatus': {
        return this.productStatus !== 'SUCCESS' && this.productStatus !== 'INITIAL' ? true : false;
      }
      case 'carrierServiceLevelStatus': {
        return this.carrierServiceLevelStatus !== 'SUCCESS' && this.carrierServiceLevelStatus !== 'INITIAL' ? true : false;
      }
      case 'revenueStatus': {
        return this.checkCostVsRevenue && this.revenueStatus !== 'SUCCESS' && this.revenueStatus !== 'INITIAL' ? true : false;
      }
      default: {
        return true;
      }
    }
  }

  getMessage(fieldName): string {
    switch (fieldName) {
      case 'remoteOrderStateStatus': {
        switch ( this.remoteOrderStateStatus ) {
          case 'REVIEW': {
            return LanguagePipe.get('Remote Store Order Needs Review', 'compressSpaces');
          }
          case 'USER_OVERRIDE': {
            return LanguagePipe.get('Remote Store Order Overridden', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'uniqueRemoteOrderIdStatus': {
        switch ( this.uniqueRemoteOrderIdStatus ) {
          case 'ERROR': {
            return LanguagePipe.get('Remote Store Order Id Has Already Been Created', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'ignoreStatus': {
        switch ( this.ignoreStatus ) {
          case 'IGNORE': {
            return LanguagePipe.get('Order Is Being Ignored', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'userHoldStatus': {
        switch ( this.userHoldStatus ) {
          case 'HOLD': {
            return LanguagePipe.get('Order On User Hold', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'releaseStatus': {
        switch ( this.releaseStatus ) {
          case 'READY': {
            return LanguagePipe.get('Ready To Release To Production', 'compressSpaces');
          }
          case 'SUCCESS': {
            return LanguagePipe.get('Released To Production', 'compressSpaces');
          }
          case 'NOT_READY': {
            return LanguagePipe.get('Not Ready To Release To Production', 'compressSpaces');
          }
          case 'IN_PROGRESS': {
            return LanguagePipe.get('Releasing To Production', 'compressSpaces');
          }
          case 'ERROR': {
            return LanguagePipe.get('Error Releasing To Production', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'functionalStatus': { // Functional Status messages are expressed by the address, product, carrierServiceLevel, and productAndShippingRevenue status that it aggregates
        switch ( this.functionalStatus ) {
          default: {
            return '';
          }
        }
      }
      case 'ecommerceOrderStatus': {
        switch ( this.ecommerceOrderStatus ) {
          default: {
            return LanguagePipe.get(this.ecommerceOrderStatus, 'compressSpaces');
          }
        }
      }
      case 'addressStatus': {
        switch ( this.addressStatus ) {
          case 'ERROR': {
            return LanguagePipe.get('Address Error', 'compressSpaces');
          }
          case 'INVALID_FOR_SERVICE_LEVEL': {
            return LanguagePipe.get('Address Is Not Valid For The Selected Shipping', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'productStatus': {
        switch ( this.productStatus ) {
          case 'ERROR': {
            return LanguagePipe.get('Problem Matching Products', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'carrierServiceLevelStatus': {
        switch ( this.carrierServiceLevelStatus ) {
          case 'ERROR': {
            return LanguagePipe.get('Problem Getting Carrier and Service Level From The Incoming Order', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'revenueStatus': {
        switch ( this.revenueStatus ) {
          case 'ERROR': {
            return LanguagePipe.get('Problem Getting Revenue From The In Coming Order', 'compressSpaces');
          }
          default: {
            return '';
          }
        }
      }
      case 'costVsRevenueStatus': {
        switch ( this.costVsRevenueStatus ) {
          case 'REVIEW': {
            return LanguagePipe.get('Cost Of Production Exceeds The Threshold Relative To Revenue', 'compressSpaces');
          }
          case 'WAITING_FOR_COSTS': {
            return '';
          }
          default: {
            return '';
          }
        }
      }
      default: {
        return 'Default';
      }
    }
  }
}
